"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prependQuestionToForm = void 0;
var lodash_1 = require("lodash");
function prependQuestionToForm(newQuestion, documentVm) {
    var newDocument = lodash_1.cloneDeep(documentVm);
    newDocument.form.sections[0].items = __spreadArrays([
        newQuestion
    ], newDocument.form.sections[0].items);
    return newDocument;
}
exports.prependQuestionToForm = prependQuestionToForm;
//# sourceMappingURL=prependQuestionToForm.js.map